import React from 'react'
import DataTableStatic from 'components/organisms/data-table-static'
import customerOrderCreateShipmentTableColumns from 'domains/customer-order/molecules/create-shipment-table-columns'
import PropTypes from 'prop-types'


const propTypes = {
  data             : PropTypes.array,
  onClickItem      : PropTypes.func,
  isShipmentItems  : PropTypes.bool,
  chosenOrderItems : PropTypes.arrayOf(PropTypes.object)
}

const defaultProps = {
  data             : [],
  onClickItem      : () => {},
  isShipmentItems  : false,
  chosenOrderItems : []
}

/**
 * @param {Array<Object>} data - array of orders shipments objects
 * @param {Function} onClickItem - function to handle callback when the button clicked
 * @param {boolean} isShipmentItems - to differentiate between order item table or shipment table
 * @param {array} selectedOrderItems - array of order item objects
 */
const CustomerOrderCreateShipmentTable = ({
  data,
  onClickItem,
  isShipmentItems,
  chosenOrderItems
}) => {

  const columns = customerOrderCreateShipmentTableColumns(onClickItem, isShipmentItems, chosenOrderItems)

  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
    />
  )
}

CustomerOrderCreateShipmentTable.propTypes    = propTypes
CustomerOrderCreateShipmentTable.defaultProps = defaultProps

export default CustomerOrderCreateShipmentTable